
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("fm5VO", function(module, exports) {

$parcel$export(module.exports, "LockScreenExperimentShared", () => $c499ca20bbfbc08c$export$9cb33fb0dce2d2e3);

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $8Kzvy = parcelRequire("8Kzvy");

var $0cdA8 = parcelRequire("0cdA8");

var $9CJ0P = parcelRequire("9CJ0P");
var $jB5IB = parcelRequire("jB5IB");

var $7rIIy = parcelRequire("7rIIy");

var $2mV1Q = parcelRequire("2mV1Q");

var $cPEpP = parcelRequire("cPEpP");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $6WXNs = parcelRequire("6WXNs");

var $ab6rA = parcelRequire("ab6rA");
var $g4G5S = parcelRequire("g4G5S");


var $74ny8 = parcelRequire("74ny8");

var $3FDyv = parcelRequire("3FDyv");
const $c499ca20bbfbc08c$var$LockScreenExperimentSharedComponent = ()=>{
    const isScreenLocked = (0, $jB5IB.useIsScreenLocked)();
    const [, lockScreenActions] = (0, $jB5IB.useLockScreenController)();
    const fireFeatureExposed = (0, $3FDyv.useFeatureExposedEvent)();
    const appEditions = (0, $ab6rA.useAppEditions)();
    const productEntitlementDetails = (0, $g4G5S.useProductEntitlementDetails)();
    const { data: project } = (0, $cPEpP.useProject)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const projectType = (0, $7ZZxN.toProjectType)(project?.type);
    const edition = projectType && (0, $6WXNs.getEditionForProject)(projectType, appEditions);
    const productKey = projectType && (0, $7ZZxN.projectTypeToCanonicalId)(projectType);
    const entitlementDetails = productKey && productEntitlementDetails?.[productKey];
    const billingSourceSystem = entitlementDetails?.billingSourceSystem || 'HAMS';
    const entitlementId = entitlementDetails?.entitlementId;
    const { eligible: eligible, ineligibilityReason: ineligibilityReason } = (0, $3FDyv.getLocalEligibility)({
        projectType: projectType,
        edition: edition,
        entitlementDetails: entitlementDetails,
        billingSourceSystem: billingSourceSystem,
        entitlementId: entitlementId
    });
    const prefetchAnalyticsAttributes = (0, $eUqFw.useMemo)(()=>({
            edition: edition,
            productKey: productKey,
            productEntitlementDetails: productEntitlementDetails
        }), [
        edition,
        productKey,
        productEntitlementDetails
    ]);
    const handleLockScreenServiceError = (0, $eUqFw.useCallback)((err)=>{
        // this will never be true as we only fetch supported projectTypes
        if (!(0, $9CJ0P.isSupportedProjectType)(projectType)) return;
        const error = (0, $3FDyv.transformError)(err);
        fireFeatureExposed('fetchEligibilityFailed', projectType, {
            ...prefetchAnalyticsAttributes,
            error: error
        }, edition);
        lockScreenActions.unlockScreen();
    }, [
        projectType,
        fireFeatureExposed,
        prefetchAnalyticsAttributes,
        edition,
        lockScreenActions
    ]);
    const { loading: loadingLockScreenDetails, data: lockScreenDetails, error: lockScreenDetailsError, fetch: fetchLockScreenDetails } = (0, $74ny8.useLockScreenService)({
        entitlementId: entitlementId,
        onError: handleLockScreenServiceError
    });
    const updateLockScreen = (0, $eUqFw.useCallback)(async (supportedProjectType, projectEdition)=>{
        // unlock screen until we handle loading state or store data
        lockScreenActions.unlockScreen();
        const data = await fetchLockScreenDetails();
        const isOnVariationForTrialEndLockScreen = ()=>{
            const { cohort: cohort } = (0, $9CJ0P.getStatSigCohortAndExposureFunction)({
                projectType: supportedProjectType,
                edition: projectEdition
            });
            return cohort === 'variation';
        };
        const showForUserUsageUnderLimit = (0, $9CJ0P.getShowForUserUsageUnderLimit)({
            projectType: supportedProjectType,
            edition: projectEdition
        });
        // if there is no data then an error occurred and is handled in handleLockScreenServiceError
        if (data) {
            if (!data.predunning) {
                fireFeatureExposed('notInPreDunning', supportedProjectType, {
                    ...prefetchAnalyticsAttributes,
                    lockScreenDetails: data
                }, projectEdition);
                lockScreenActions.unlockScreen();
            } else if (!showForUserUsageUnderLimit && !data.usageOverLimit) {
                fireFeatureExposed('underUserLimit', supportedProjectType, {
                    ...prefetchAnalyticsAttributes,
                    lockScreenDetails: data
                }, projectEdition);
                lockScreenActions.unlockScreen();
            } else {
                const { isEnrolled: isEndOfTrialMessageExperimentEnrolled, cohort: endOfTrialCohort, fireStatsigExperimentExposure: fireStatsigEotExperimentExposure } = (0, $8Kzvy.getEndOfTrialMessageExperiment)(supportedProjectType);
                if (isEndOfTrialMessageExperimentEnrolled && projectEdition === (0, $6WXNs.STANDARD_EDITION)) {
                    fireStatsigEotExperimentExposure();
                    (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'feature exposed', 'endOfTrialMessaging', {
                        cohort: endOfTrialCohort,
                        growthInitiative: 'transmuters',
                        projectType: supportedProjectType,
                        edition: projectEdition
                    });
                    if (endOfTrialCohort === 'variation') {
                        fireFeatureExposed('isVariationForEOTModal', supportedProjectType, {
                            ...prefetchAnalyticsAttributes,
                            lockScreenDetails: data
                        }, projectEdition);
                        lockScreenActions.unlockScreen();
                        return;
                    }
                }
                fireFeatureExposed(null, supportedProjectType, {
                    ...prefetchAnalyticsAttributes,
                    lockScreenDetails: data
                }, projectEdition);
                if (isOnVariationForTrialEndLockScreen()) lockScreenActions.lockScreen();
                else lockScreenActions.unlockScreen();
            }
        }
    }, [
        lockScreenActions,
        fetchLockScreenDetails,
        fireFeatureExposed,
        prefetchAnalyticsAttributes,
        createAnalyticsEvent
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!(0, $9CJ0P.isSupportedProjectType)(projectType)) lockScreenActions.unlockScreen();
        else if (!(0, $9CJ0P.isTrialEndLockScreenEnabledForProject)({
            projectType: projectType,
            edition: edition
        })) // this supports rollout % of different project types
        lockScreenActions.unlockScreen();
        else if (!eligible) {
            fireFeatureExposed(ineligibilityReason, projectType, prefetchAnalyticsAttributes, edition);
            lockScreenActions.unlockScreen();
        } else updateLockScreen(projectType, edition);
    }, [
        projectType,
        eligible,
        ineligibilityReason,
        prefetchAnalyticsAttributes,
        fireFeatureExposed,
        lockScreenActions,
        updateLockScreen,
        edition
    ]);
    const analyticsAttributes = (0, $eUqFw.useMemo)(()=>({
            ...prefetchAnalyticsAttributes,
            lockScreenDetails: lockScreenDetails
        }), [
        prefetchAnalyticsAttributes,
        lockScreenDetails
    ]);
    if (isScreenLocked) {
        if ((0, $9CJ0P.isJiraSoftwareOrJiraCorePremium)({
            projectType: projectType,
            appEditions: appEditions
        })) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2mV1Q.LockScreenModal), {
            predunningDaysLeft: lockScreenDetails?.predunningDaysLeft,
            usageOverLimit: lockScreenDetails?.usageOverLimit,
            transactionAccountId: lockScreenDetails?.transactionAccountId,
            entitlementId: entitlementId,
            invoiceGroupId: lockScreenDetails?.invoiceGroupId,
            isBillingAdmin: lockScreenDetails?.isBillingAdmin,
            isBillingUser: lockScreenDetails?.isBillingUser
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
            id: "lock-screen-experiment-async",
            fallback: "unmount",
            onError: ()=>lockScreenActions.unlockScreen(),
            packageName: (0, $a733f78220833320$export$b8b9d90f9e5bd72b),
            teamName: (0, $a733f78220833320$export$d57b6b390e78d90f)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7rIIy.AsyncLazyLockScreenExperiment), {
            showSkeleton: loadingLockScreenDetails,
            showError: !!lockScreenDetailsError,
            predunningDaysLeft: lockScreenDetails?.predunningDaysLeft,
            isBillingAdmin: lockScreenDetails?.isBillingAdmin,
            isBillingUser: lockScreenDetails?.isBillingUser,
            transactionAccountId: lockScreenDetails?.transactionAccountId,
            invoiceGroupId: lockScreenDetails?.invoiceGroupId,
            usageOverLimit: lockScreenDetails?.usageOverLimit,
            entitlementId: entitlementId,
            projectType: projectType,
            analyticsAttributes: analyticsAttributes
        }));
    }
    return null;
};
const $c499ca20bbfbc08c$export$9cb33fb0dce2d2e3 = ()=>{
    const [, lockScreenActions] = (0, $jB5IB.useLockScreenController)();
    const appEditions = (0, $ab6rA.useAppEditions)();
    if ((0, $9CJ0P.isTrialEndLockScreenEnabledForAnyProjectType)(appEditions)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "lock-screen-experiment-shared",
        fallback: "unmount",
        onError: ()=>lockScreenActions.unlockScreen(),
        packageName: (0, $a733f78220833320$export$b8b9d90f9e5bd72b),
        teamName: (0, $a733f78220833320$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c499ca20bbfbc08c$var$LockScreenExperimentSharedComponent, null));
    return null;
};
$c499ca20bbfbc08c$export$9cb33fb0dce2d2e3.displayName = 'LockScreenExperimentShared';

});
parcelRegister("8Kzvy", function(module, exports) {

$parcel$export(module.exports, "getEndOfTrialMessageAudience", () => $07630406621a6851$export$35c002d8cb752227);
$parcel$export(module.exports, "getEndOfTrialMessageExperiment", () => $07630406621a6851$export$cc0a7ba2b7691053);

var $jG2Eu = parcelRequire("jG2Eu");

var $7ZZxN = parcelRequire("7ZZxN");

var $6q8F1 = parcelRequire("6q8F1");

var $79xbN = parcelRequire("79xbN");

var $ejxbt = parcelRequire("ejxbt");
const $07630406621a6851$export$35c002d8cb752227 = (preDunningDaysLeft, projectType)=>{
    if (preDunningDaysLeft >= 0 && preDunningDaysLeft <= 13) return (0, $ejxbt.END_OF_TRIAL_MESSAGE_AUDIENCES)[projectType][preDunningDaysLeft];
    return undefined;
};
const $07630406621a6851$var$getEndOfTrialMessageExperimentConfig = (projectType)=>{
    switch(projectType){
        case 0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT:
            return (0, $79xbN.UNSAFE_noExposureExp)('end_of_trial_ep_message_jpd');
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            return (0, $79xbN.UNSAFE_noExposureExp)('end_of_trial_ep_message_jsm');
        default:
            throw new Error(`Invalid EOTM projectType: ${projectType}`);
    }
};
const $07630406621a6851$export$cc0a7ba2b7691053 = (projectType)=>{
    if (!(0, $6q8F1.isSupportedEotmProjectType)(projectType)) return {
        isEnrolled: false,
        cohort: 'not-enrolled',
        fireStatsigExperimentExposure: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
    };
    const [endOfTrialMessageConfig, fireStatsigExperimentExposure] = $07630406621a6851$var$getEndOfTrialMessageExperimentConfig(projectType);
    const cohort = endOfTrialMessageConfig.get('cohort', 'not-enrolled');
    return {
        isEnrolled: cohort !== 'not-enrolled',
        cohort: cohort,
        fireStatsigExperimentExposure: fireStatsigExperimentExposure
    };
};

});
parcelRegister("6q8F1", function(module, exports) {

$parcel$export(module.exports, "isSupportedEotmProjectType", () => $6e7c205eaf647115$export$177b0b5ff46e69ac);

var $7ZZxN = parcelRequire("7ZZxN");
const $6e7c205eaf647115$var$SUPPORTED_EOTM_PROJECT_TYPES = [
    (0, $7ZZxN.SERVICE_DESK_PROJECT),
    (0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT)
];
const $6e7c205eaf647115$export$177b0b5ff46e69ac = (value)=>{
    const projectType = (0, $7ZZxN.toProjectType)(value);
    return(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    !!projectType && $6e7c205eaf647115$var$SUPPORTED_EOTM_PROJECT_TYPES.includes(projectType));
};

});


parcelRegister("9CJ0P", function(module, exports) {

$parcel$export(module.exports, "getStatSigCohortAndExposureFunction", () => $5fd6ec1c86252c53$export$dcea8823e3724239);
$parcel$export(module.exports, "isSupportedProjectType", () => $5fd6ec1c86252c53$export$fa630a47d84fb39a);
$parcel$export(module.exports, "isTrialEndLockScreenEnabledForProject", () => $5fd6ec1c86252c53$export$cd0c634567b0c255);
$parcel$export(module.exports, "isTrialEndLockScreenEnabledForAnyProjectType", () => $5fd6ec1c86252c53$export$26a64e0070bbd19d);
$parcel$export(module.exports, "getShowForUserUsageUnderLimit", () => $5fd6ec1c86252c53$export$8d52cd5130a1ee4e);
$parcel$export(module.exports, "isJiraSoftwareOrJiraCorePremium", () => $5fd6ec1c86252c53$export$16acee0f79c890d4);

var $jG2Eu = parcelRequire("jG2Eu");

var $7ZZxN = parcelRequire("7ZZxN");

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $6WXNs = parcelRequire("6WXNs");
const $5fd6ec1c86252c53$var$TRIAL_END_LOCK_SCREEN_JSM_STATSIG_FLAG = 'jsm_trial_end_lock_screen_experiment';
const $5fd6ec1c86252c53$var$TRIAL_END_LOCK_SCREEN_JPD_STATSIG_FLAG = 'jpd_trial_end_lock_screen_experiment';
const $5fd6ec1c86252c53$var$TRIAL_END_LOCK_SCREEN_JSW_STATSIG_FLAG = 'jsw_trial_end_lock_screen_experiment';
const $5fd6ec1c86252c53$var$TRIAL_END_LOCK_SCREEN_JIRA_PREMIUM_STATSIG_FLAG = 'jsw_premium_eot_lock_screen';
const $5fd6ec1c86252c53$var$TRIAL_END_LOCK_SCREEN_JSM_FF = 'jsm-trial-end-lock-screen-experiment_nowmr';
const $5fd6ec1c86252c53$var$TRIAL_END_LOCK_SCREEN_JPD_FF = 'jpd-trial-end-lock-screen-experiment';
const $5fd6ec1c86252c53$var$TRIAL_END_LOCK_SCREEN_JSW_FF = 'jsw-trial-end-lock-screen-experiment_ieq79';
const $5fd6ec1c86252c53$var$TRIAL_END_LOCK_SCREEN_JIRA_PREMIUM_STATSIG_FG = 'jsw_premium_eot_lock_screen_feature_gate';
const $5fd6ec1c86252c53$export$37f449592e04a567 = [
    (0, $7ZZxN.SERVICE_DESK_PROJECT),
    (0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT),
    (0, $7ZZxN.SOFTWARE_PROJECT),
    (0, $7ZZxN.CORE_PROJECT)
];
const $5fd6ec1c86252c53$var$PROJECT_FLAGS = {
    [(0, $7ZZxN.SERVICE_DESK_PROJECT)]: {
        [(0, $6WXNs.STANDARD_EDITION)]: {
            gatingFlagType: 'ff',
            gatingFlag: $5fd6ec1c86252c53$var$TRIAL_END_LOCK_SCREEN_JSM_FF,
            statsig: $5fd6ec1c86252c53$var$TRIAL_END_LOCK_SCREEN_JSM_STATSIG_FLAG
        }
    },
    [(0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT)]: {
        [(0, $6WXNs.STANDARD_EDITION)]: {
            gatingFlagType: 'ff',
            gatingFlag: $5fd6ec1c86252c53$var$TRIAL_END_LOCK_SCREEN_JPD_FF,
            statsig: $5fd6ec1c86252c53$var$TRIAL_END_LOCK_SCREEN_JPD_STATSIG_FLAG
        }
    },
    [(0, $7ZZxN.SOFTWARE_PROJECT)]: {
        [(0, $6WXNs.STANDARD_EDITION)]: {
            gatingFlagType: 'ff',
            gatingFlag: $5fd6ec1c86252c53$var$TRIAL_END_LOCK_SCREEN_JSW_FF,
            statsig: $5fd6ec1c86252c53$var$TRIAL_END_LOCK_SCREEN_JSW_STATSIG_FLAG
        },
        [(0, $6WXNs.PREMIUM_EDITION)]: {
            gatingFlagType: 'fg',
            gatingFlag: $5fd6ec1c86252c53$var$TRIAL_END_LOCK_SCREEN_JIRA_PREMIUM_STATSIG_FG,
            statsig: $5fd6ec1c86252c53$var$TRIAL_END_LOCK_SCREEN_JIRA_PREMIUM_STATSIG_FLAG,
            showForUserUsageUnderLimit: true
        }
    },
    [(0, $7ZZxN.CORE_PROJECT)]: {
        [(0, $6WXNs.PREMIUM_EDITION)]: {
            gatingFlagType: 'fg',
            gatingFlag: $5fd6ec1c86252c53$var$TRIAL_END_LOCK_SCREEN_JIRA_PREMIUM_STATSIG_FG,
            statsig: $5fd6ec1c86252c53$var$TRIAL_END_LOCK_SCREEN_JIRA_PREMIUM_STATSIG_FLAG,
            showForUserUsageUnderLimit: true
        }
    }
};
const $5fd6ec1c86252c53$export$dcea8823e3724239 = ({ projectType: projectType, edition: edition })=>{
    let expConfig;
    let fireExpExperimentExposure;
    switch(projectType){
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            if (edition === (0, $6WXNs.STANDARD_EDITION)) [expConfig, fireExpExperimentExposure] = (0, $79xbN.UNSAFE_noExposureExp)('jsm_trial_end_lock_screen_experiment');
            break;
        case 0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT:
            if (edition === (0, $6WXNs.STANDARD_EDITION)) [expConfig, fireExpExperimentExposure] = (0, $79xbN.UNSAFE_noExposureExp)('jpd_trial_end_lock_screen_experiment');
            break;
        case 0, $7ZZxN.SOFTWARE_PROJECT:
            if (edition === (0, $6WXNs.STANDARD_EDITION)) [expConfig, fireExpExperimentExposure] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_trial_end_lock_screen_experiment');
            else if (edition === (0, $6WXNs.PREMIUM_EDITION)) [expConfig, fireExpExperimentExposure] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_premium_eot_lock_screen');
            break;
        case 0, $7ZZxN.CORE_PROJECT:
            if (edition === (0, $6WXNs.PREMIUM_EDITION)) [expConfig, fireExpExperimentExposure] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_premium_eot_lock_screen');
            break;
        default:
            break;
    }
    return {
        cohort: expConfig ? expConfig.get('cohort', 'not-enrolled') : 'not-enrolled',
        fireExpExperimentExposure: fireExpExperimentExposure ?? (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
    };
};
const $5fd6ec1c86252c53$export$fa630a47d84fb39a = (value)=>{
    const projectType = (0, $7ZZxN.toProjectType)(value);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return !!projectType && $5fd6ec1c86252c53$export$37f449592e04a567.includes(projectType);
};
const $5fd6ec1c86252c53$export$cd0c634567b0c255 = ({ projectType: projectType, edition: edition })=>{
    const { cohort: cohort } = $5fd6ec1c86252c53$export$dcea8823e3724239({
        projectType: projectType,
        edition: edition
    });
    switch(projectType){
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            if (edition === (0, $6WXNs.STANDARD_EDITION)) return (0, $1ybV0.ff)('jsm-trial-end-lock-screen-experiment_nowmr') && cohort !== 'not-enrolled';
            break;
        case 0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT:
            if (edition === (0, $6WXNs.STANDARD_EDITION)) return (0, $1ybV0.ff)('jpd-trial-end-lock-screen-experiment') && cohort !== 'not-enrolled';
            break;
        case 0, $7ZZxN.SOFTWARE_PROJECT:
            if (edition === (0, $6WXNs.STANDARD_EDITION)) return (0, $1ybV0.ff)('jsw-trial-end-lock-screen-experiment_ieq79') && cohort !== 'not-enrolled';
            if (edition === (0, $6WXNs.PREMIUM_EDITION)) return (0, $eI5EY.fg)('jsw_premium_eot_lock_screen_feature_gate') && cohort !== 'not-enrolled';
            break;
        case 0, $7ZZxN.CORE_PROJECT:
            if (edition === (0, $6WXNs.PREMIUM_EDITION)) return (0, $eI5EY.fg)('jsw_premium_eot_lock_screen_feature_gate') && cohort !== 'not-enrolled';
            break;
        default:
            return false;
    }
    return false;
};
const $5fd6ec1c86252c53$export$26a64e0070bbd19d = (appEditions)=>$5fd6ec1c86252c53$export$37f449592e04a567.some((projectType)=>{
        const edition = projectType && appEditions && (0, $6WXNs.getEditionForProject)(projectType, appEditions);
        return $5fd6ec1c86252c53$export$cd0c634567b0c255({
            projectType: projectType,
            edition: edition
        });
    });
const $5fd6ec1c86252c53$export$8d52cd5130a1ee4e = ({ projectType: projectType, edition: edition })=>!!edition && !!$5fd6ec1c86252c53$var$PROJECT_FLAGS[projectType][edition]?.showForUserUsageUnderLimit;
const $5fd6ec1c86252c53$export$16acee0f79c890d4 = ({ projectType: projectType, appEditions: appEditions })=>projectType && (projectType === (0, $7ZZxN.SOFTWARE_PROJECT) || projectType === (0, $7ZZxN.CORE_PROJECT)) && (0, $6WXNs.getEditionForProject)(projectType, appEditions) === (0, $6WXNs.PREMIUM_EDITION);

});

parcelRegister("jB5IB", function(module, exports) {

$parcel$export(module.exports, "useLockScreenController", () => $843e8034a8f1654e$export$e035a0795b3eefc0);
$parcel$export(module.exports, "useIsScreenLocked", () => $843e8034a8f1654e$export$8a9d757ad1774a77);
$parcel$export(module.exports, "useHideTopNavForLockScreen", () => $843e8034a8f1654e$export$d2171d276bb2e6f3);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $79xbN = parcelRequire("79xbN");

var $cPEpP = parcelRequire("cPEpP");

var $ab6rA = parcelRequire("ab6rA");

var $9CJ0P = parcelRequire("9CJ0P");
const $843e8034a8f1654e$export$111f5c5aa8d2ad30 = (0, $a61MH.createStore)({
    initialState: {
        isLocked: false
    },
    actions: {
        lockScreen: ()=>({ setState: setState })=>setState({
                    isLocked: true
                }),
        unlockScreen: ()=>({ setState: setState })=>setState({
                    isLocked: false
                })
    },
    name: 'LockScreenExperiment'
});
const $843e8034a8f1654e$export$e035a0795b3eefc0 = (0, $ggKAj.createHook)($843e8034a8f1654e$export$111f5c5aa8d2ad30);
const $843e8034a8f1654e$export$8a9d757ad1774a77 = ()=>{
    const [lockScreenState] = $843e8034a8f1654e$export$e035a0795b3eefc0();
    const { loading: loadingProject, data: project } = (0, $cPEpP.useProject)();
    const appEditions = (0, $ab6rA.useAppEditions)();
    return (0, $9CJ0P.isTrialEndLockScreenEnabledForAnyProjectType)(appEditions) && !loadingProject && (0, $9CJ0P.isSupportedProjectType)(project?.type) && lockScreenState.isLocked;
};
const $843e8034a8f1654e$export$d2171d276bb2e6f3 = ()=>{
    const [lockScreenState] = $843e8034a8f1654e$export$e035a0795b3eefc0();
    const { loading: loadingProject, data: project } = (0, $cPEpP.useProject)();
    const appEditions = (0, $ab6rA.useAppEditions)();
    const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_premium_eot_lock_screen');
    if (expConfig.get('cohort', 'not-enrolled') === 'variation') return (0, $9CJ0P.isTrialEndLockScreenEnabledForAnyProjectType)(appEditions) && !loadingProject && (0, $9CJ0P.isSupportedProjectType)(project?.type) && !(0, $9CJ0P.isJiraSoftwareOrJiraCorePremium)({
        projectType: project?.type,
        appEditions: appEditions
    }) && lockScreenState.isLocked;
    // same returned value as useIsScreenLocked
    return (0, $9CJ0P.isTrialEndLockScreenEnabledForAnyProjectType)(appEditions) && !loadingProject && (0, $9CJ0P.isSupportedProjectType)(project?.type) && lockScreenState.isLocked;
};

});

parcelRegister("7rIIy", function(module, exports) {

$parcel$export(module.exports, "AsyncLazyLockScreenExperiment", () => $bf0c273b57d493ee$export$570466d2125f2d64);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

/* istanbul ignore next */ // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $bf0c273b57d493ee$var$LazyLockScreenExperiment = (0, $7rh0R.lazy)(()=>(parcelRequire("2Y6qn")).then((module)=>module.LockScreenExperiment), {
    moduleId: "./src/packages/growth/end-of-trial/lock-screen-experiment/src/ui/index.tsx"
});
const $bf0c273b57d493ee$export$570466d2125f2d64 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "lock-screen-experiment",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bf0c273b57d493ee$var$LazyLockScreenExperiment, props));

});
parcelRegister("2Y6qn", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('hPzOn'),
            load('2hmUs'),
            load('bCeK4'),
            load('87ibT')
        ]);
        const value = parcelRequire('8Ma8M');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("hPzOn"),
        load("2hmUs"),
        load("bCeK4"),
        load("87ibT")
    ]).then(()=>parcelRequire('8Ma8M'));
}

});


parcelRegister("2mV1Q", function(module, exports) {

$parcel$export(module.exports, "LockScreenModal", () => $c9b6324f18d0d1b6$export$fd33eab528eb744e);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $8WuJm = parcelRequire("8WuJm");

var $dDfZo = parcelRequire("dDfZo");
const $c9b6324f18d0d1b6$export$fd33eab528eb744e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "jiraPremiumEotModal",
        fallback: "unmount",
        packageName: "jiraLockScreenExperiment",
        // eslint-disable-next-line jira/js/team-name-enforcer-for-error-analytics
        teamName: "jlove-makkuro"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "jiraPremiumEotModal",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        attributes: {
            ...props.analyticsAttributes,
            predunningDaysLeft: props.predunningDaysLeft,
            usageOverLimit: props.usageOverLimit,
            isBillingAdmin: props.isBillingAdmin,
            isBillingUser: props.isBillingUser
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dDfZo.AsyncLockScreenModal), props)));

});
// SCREENS
const $41ea3621645e2acc$export$f636b5b56f1d624a = 'Screen';
const $41ea3621645e2acc$export$9d2de6eebf7462b5 = 'Drawer';
const $41ea3621645e2acc$export$1171103ea9083ffa = 'Modal';
const $41ea3621645e2acc$export$cae2783c9279926 = 'InlineDialog';
const $41ea3621645e2acc$export$d1123261ca8831d2 = 'Dropdown';
const $41ea3621645e2acc$export$238d30785c4bca84 = 'Banner';
const $41ea3621645e2acc$export$a1562d08625f5d7e = 'UI';
const $41ea3621645e2acc$export$947dac6c72b26f81 = 'TRACK';
const $41ea3621645e2acc$export$f1d537d508d2945a = 'SCREEN';
const $41ea3621645e2acc$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("dDfZo", function(module, exports) {

$parcel$export(module.exports, "AsyncLockScreenModal", () => $277cae1df1d3bf88$export$2920d4e906ecafcf);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8oDQr = parcelRequire("8oDQr");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $277cae1df1d3bf88$var$LazyLockScreenModal = (0, $7rh0R.lazy)(()=>(parcelRequire("cbMif")).then((module)=>module.LockScreenModalComponent), {
    moduleId: "./src/packages/growth/end-of-trial/lock-screen-experiment/src/ui/lock-screen-modal/main.tsx"
});
const $277cae1df1d3bf88$export$2920d4e906ecafcf = (props)=>{
    const shouldShowJiraLockScreen = (0, $8oDQr.useShouldShowJiraLockScreen)({
        predunningDaysLeft: props.predunningDaysLeft
    });
    if (!shouldShowJiraLockScreen) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7rh0R.LazySuspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($277cae1df1d3bf88$var$LazyLockScreenModal, props), ";");
};

});
parcelRegister("8oDQr", function(module, exports) {

$parcel$export(module.exports, "useShouldShowJiraLockScreen", () => $99981a64a78620c3$export$780fb33e5d1dd7ca);
$parcel$export(module.exports, "useUpdateLastSeenOnDismiss", () => $99981a64a78620c3$export$3df1ce307ab1bef8);
/* eslint-disable jira/js/team-name-enforcer-for-error-analytics */ 
var $eUqFw = parcelRequire("eUqFw");

var $aZaPn = parcelRequire("aZaPn");

var $48bs8 = parcelRequire("48bs8");

var $eEzyV = parcelRequire("eEzyV");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $gd0Sp = parcelRequire("gd0Sp");

var $grd9K = parcelRequire("grd9K");
const $99981a64a78620c3$var$oneDay = 86400000;
const $99981a64a78620c3$export$94cfaeb7db054b67 = 'jira-eot-lock-screen-modal.last-seen-time';
const $99981a64a78620c3$export$ddcffe0146c8f882 = (0, $aZaPn.createLocalStorageProvider)('jsw-onboarding-premium-eot-lock-screen');
const $99981a64a78620c3$export$c5fd9d1ed589afa5 = async ()=>{
    // @todo: Haven't managed to find a frontendconfig query in AGG. If it existed we could convert to Relay
    const { user: user } = await (0, $lRmyA.performGetRequest)(`/rest/internal/latest/frontendconfig/properties?user=${$99981a64a78620c3$export$94cfaeb7db054b67}`);
    return user[$99981a64a78620c3$export$94cfaeb7db054b67];
};
const $99981a64a78620c3$export$488572d3925ac859 = async ()=>{
    const cachedLastTimeSeen = $99981a64a78620c3$export$ddcffe0146c8f882.get($99981a64a78620c3$export$94cfaeb7db054b67);
    if (cachedLastTimeSeen) return cachedLastTimeSeen;
    const lastTimeSeen = await $99981a64a78620c3$export$c5fd9d1ed589afa5();
    if (lastTimeSeen) $99981a64a78620c3$export$ddcffe0146c8f882.set($99981a64a78620c3$export$94cfaeb7db054b67, lastTimeSeen);
    return lastTimeSeen;
};
const $99981a64a78620c3$export$2b4a82b6539805be = async (userAccountId, date)=>{
    try {
        $99981a64a78620c3$export$ddcffe0146c8f882.set($99981a64a78620c3$export$94cfaeb7db054b67, date);
        await (0, $48bs8.setUserProperties)('', userAccountId, $99981a64a78620c3$export$94cfaeb7db054b67, date);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'updateModalLastSeenTime',
                packageName: 'jiraLockScreenExperiment',
                teamName: 'jlove-makkuro'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};
const $99981a64a78620c3$export$780fb33e5d1dd7ca = ({ predunningDaysLeft: predunningDaysLeft })=>{
    const isFetched = (0, $eUqFw.useRef)(false);
    const { atlassianAccountId: atlassianAccountId } = (0, $gd0Sp.useTenantContext)();
    const isInLastSevenPredunningDays = (0, $grd9K.lastSevenPredunningDaysLeft)(predunningDaysLeft);
    const request = (0, $eUqFw.useCallback)(async ()=>{
        try {
            if (!atlassianAccountId) {
                (0, $guiFP.default)({
                    error: new Error('No atlassian account id'),
                    meta: {
                        id: 'fetchModalLastSeenTime',
                        packageName: 'jiraLockScreenExperiment',
                        teamName: 'jlove-makkuro'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                return Date.now(); // if no account id provided, consider as no screen shown
            }
            const result = await $99981a64a78620c3$export$488572d3925ac859();
            return result || null;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                error: error,
                meta: {
                    id: 'fetchModalLastSeenTime',
                    packageName: 'jiraLockScreenExperiment',
                    teamName: 'jlove-makkuro'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            return undefined;
        }
    }, [
        atlassianAccountId
    ]);
    const { loading: loading, data: data, error: error, fetch: fetch } = (0, $eEzyV.useService)(request);
    (0, $eUqFw.useEffect)(()=>{
        if (data !== undefined || loading || error || isFetched.current) return;
        // modal is always shown if user is in last 7 days of predunning
        // so no need to check the last seen time
        if (isInLastSevenPredunningDays) return;
        isFetched.current = true;
        fetch();
    }, [
        data,
        error,
        fetch,
        isInLastSevenPredunningDays,
        loading
    ]);
    const shouldShowJiraLockScreen = (0, $eUqFw.useMemo)(()=>{
        // No need to wait for an API response as we always show the modal in the last 7 days of predunning
        if (isInLastSevenPredunningDays) return true;
        // Wait for the local storage cache or API response to determine if we should show the modal
        if (data === undefined || loading || error) return false;
        // If user has not seen the modal before we should show it
        if (data === null) return true;
        // When the user has seen the modal before, we should show it again if they haven't seen it in the last 24 hours
        const now = Date.now();
        const lastSeenTime = Number(data);
        const hasNotSeenLockScreenInLastDay = now - lastSeenTime > $99981a64a78620c3$var$oneDay;
        return hasNotSeenLockScreenInLastDay;
    }, [
        data,
        error,
        isInLastSevenPredunningDays,
        loading
    ]);
    return shouldShowJiraLockScreen;
};
const $99981a64a78620c3$export$3df1ce307ab1bef8 = ()=>{
    const { atlassianAccountId: atlassianAccountId } = (0, $gd0Sp.useTenantContext)();
    const updateLastSeen = (0, $eUqFw.useCallback)(()=>{
        const now = Date.now();
        $99981a64a78620c3$export$2b4a82b6539805be(atlassianAccountId || '', `${now}`);
    }, [
        atlassianAccountId
    ]);
    return updateLastSeen;
};

});
parcelRegister("eEzyV", function(module, exports) {

$parcel$export(module.exports, "useService", () => $cbb15d4da2e9ab10$export$6de4685a6c88b4e9);
$parcel$export(module.exports, "useLoadingStatusService", () => $cbb15d4da2e9ab10$export$c963713a27525aaf);

var $eUqFw = parcelRequire("eUqFw");
const $cbb15d4da2e9ab10$export$6de4685a6c88b4e9 = (request, initialState = {})=>{
    const [state, setState] = (0, $eUqFw.useState)({
        loading: false,
        data: undefined,
        error: undefined,
        ...initialState
    });
    const fetch = (0, $eUqFw.useCallback)(async (requestData)=>{
        setState({
            loading: true,
            error: undefined,
            data: undefined
        });
        try {
            const data = await request(requestData);
            setState({
                loading: false,
                error: undefined,
                data: data
            });
            return data;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                loading: false,
                error: error,
                data: undefined
            });
            return undefined;
        }
    }, [
        request
    ]);
    return {
        ...state,
        fetch: fetch
    };
};
const $cbb15d4da2e9ab10$export$c963713a27525aaf = (request, initialState = {})=>{
    const [loadingStatus, setLoadingStatus] = (0, $eUqFw.useState)('idle');
    const { data: data, loading: loading, error: error, fetch: fetch } = $cbb15d4da2e9ab10$export$6de4685a6c88b4e9(request, initialState);
    (0, $eUqFw.useEffect)(()=>{
        if (loading) setLoadingStatus('started');
        else if (error) setLoadingStatus('error');
        else if (data) setLoadingStatus('success');
    }, [
        data,
        loading,
        error
    ]);
    return {
        data: data,
        loadingStatus: loadingStatus,
        error: error,
        fetch: fetch
    };
};

});

parcelRegister("grd9K", function(module, exports) {

$parcel$export(module.exports, "getContentModel", () => $8dfc6a17b6749f44$export$2adc6cadf94cb15c);
$parcel$export(module.exports, "lastSevenPredunningDaysLeft", () => $8dfc6a17b6749f44$export$aa2b4d59c40834cf);

var $7ZZxN = parcelRequire("7ZZxN");

var $6WXNs = parcelRequire("6WXNs");


var $lD9Ts = parcelRequire("lD9Ts");
const $8dfc6a17b6749f44$export$2adc6cadf94cb15c = (projectType, edition)=>{
    switch(projectType){
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            return {
                aboveFreeUserLimitTitle: (0, $lD9Ts.default).aboveFreeUserLimitTitleJsm,
                belowFreeUserLimitTitle: (0, $lD9Ts.default).belowFreeUserLimitTitle,
                adminAboveFreeUserLimitInstruction: (0, $lD9Ts.default).adminAboveFreeUserLimitInstruction,
                adminBelowFreeUserLimitInstruction: (0, $lD9Ts.default).adminBelowFreeUserLimitInstruction,
                billingAdminBenefitTitle: (0, $lD9Ts.default).billingAdminBenefitTitle,
                nonBillingAdminBenefitTitle: (0, $lD9Ts.default).nonBillingAdminBenefitTitle,
                benefits: [
                    (0, $lD9Ts.default).accessAllAgents,
                    (0, $lD9Ts.default).businessHourSupport,
                    (0, $lD9Ts.default).unlimitedEmailNotification
                ],
                contactBillingAdmin: (0, $lD9Ts.default).contactBillingAdmin,
                learnMoreAboutBenefitsUrl: (0, $bbb37991b0d02a24$export$5c50e433b099ebf0),
                learnMoreUrlText: (0, $lD9Ts.default).learnMoreUrlText,
                referrer: (0, $bbb37991b0d02a24$export$203bbf35222be25b)
            };
        case 0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT:
            return {
                aboveFreeUserLimitTitle: (0, $lD9Ts.default).aboveFreeUserLimitTitleJpd,
                belowFreeUserLimitTitle: (0, $lD9Ts.default).belowFreeUserLimitTitle,
                adminAboveFreeUserLimitInstruction: (0, $lD9Ts.default).adminAboveFreeUserLimitInstruction,
                adminBelowFreeUserLimitInstruction: (0, $lD9Ts.default).adminBelowFreeUserLimitInstruction,
                billingAdminBenefitTitle: (0, $lD9Ts.default).billingAdminBenefitTitle,
                nonBillingAdminBenefitTitle: (0, $lD9Ts.default).nonBillingAdminBenefitTitle,
                benefits: [
                    (0, $lD9Ts.default).accessAllCreators,
                    (0, $lD9Ts.default).businessHourSupport,
                    (0, $lD9Ts.default).dataResidency
                ],
                contactBillingAdmin: (0, $lD9Ts.default).contactBillingAdmin,
                learnMoreAboutBenefitsUrl: (0, $bbb37991b0d02a24$export$8ac36013bcee2033),
                learnMoreUrlText: (0, $lD9Ts.default).learnMoreUrlText,
                referrer: (0, $bbb37991b0d02a24$export$128ca612adf9bcff)
            };
        case 0, $7ZZxN.SOFTWARE_PROJECT:
            switch(edition){
                case 0, $6WXNs.PREMIUM_EDITION:
                    return {
                        aboveFreeUserLimitTitle: (0, $lD9Ts.default).aboveFreeUserLimitTitleJswPremium,
                        belowFreeUserLimitTitle: (0, $lD9Ts.default).belowFreeUserLimitTitlePremium,
                        adminAboveFreeUserLimitInstruction: (0, $lD9Ts.default).adminAboveFreeUserLimitInstructionPremium,
                        adminBelowFreeUserLimitInstruction: (0, $lD9Ts.default).adminBelowFreeUserLimitInstructionPremium,
                        billingAdminBenefitTitle: (0, $lD9Ts.default).billingAdminBenefitTitlePremium,
                        nonBillingAdminBenefitTitle: (0, $lD9Ts.default).nonBillingAdminBenefitTitlePremium,
                        benefits: [
                            (0, $lD9Ts.default).crossTeamTimelines,
                            (0, $lD9Ts.default).releaseTracks,
                            (0, $lD9Ts.default).atlassianIntelligence
                        ],
                        contactBillingAdmin: (0, $lD9Ts.default).contactBillingAdminPremium,
                        learnMoreAboutBenefitsUrl: (0, $bbb37991b0d02a24$export$d3064c7b0a7e0156),
                        learnMoreUrlText: (0, $lD9Ts.default).premiumLearnMoreUrlText,
                        referrer: (0, $bbb37991b0d02a24$export$a217f4f87e1d9927),
                        showAtlassianStart: true
                    };
                case 0, $6WXNs.STANDARD_EDITION:
                default:
                    return {
                        aboveFreeUserLimitTitle: (0, $lD9Ts.default).aboveFreeUserLimitTitleJswSpork,
                        belowFreeUserLimitTitle: (0, $lD9Ts.default).belowFreeUserLimitTitle,
                        adminAboveFreeUserLimitInstruction: (0, $lD9Ts.default).adminAboveFreeUserLimitInstruction,
                        adminBelowFreeUserLimitInstruction: (0, $lD9Ts.default).adminBelowFreeUserLimitInstruction,
                        billingAdminBenefitTitle: (0, $lD9Ts.default).billingAdminBenefitTitle,
                        nonBillingAdminBenefitTitle: (0, $lD9Ts.default).nonBillingAdminBenefitTitle,
                        benefits: [
                            (0, $lD9Ts.default).accessAllUsers,
                            (0, $lD9Ts.default).businessHourSupport,
                            (0, $lD9Ts.default).userRolesAndPermissions
                        ],
                        contactBillingAdmin: (0, $lD9Ts.default).contactBillingAdmin,
                        learnMoreAboutBenefitsUrl: (0, $bbb37991b0d02a24$export$d3064c7b0a7e0156),
                        learnMoreUrlText: (0, $lD9Ts.default).learnMoreUrlText,
                        referrer: (0, $bbb37991b0d02a24$export$a217f4f87e1d9927)
                    };
            }
        default:
            throw new Error(`Unexpected projectType ${projectType}`);
    }
};
const $8dfc6a17b6749f44$export$aa2b4d59c40834cf = (predunningDaysLeft)=>predunningDaysLeft !== undefined && predunningDaysLeft >= 0 && predunningDaysLeft < 7;

});
const $bbb37991b0d02a24$export$5c50e433b099ebf0 = 'https://www.atlassian.com/software/jira/service-management/pricing';
const $bbb37991b0d02a24$export$8ac36013bcee2033 = 'https://www.atlassian.com/software/jira/product-discovery/pricing';
const $bbb37991b0d02a24$export$d3064c7b0a7e0156 = 'https://www.atlassian.com/software/jira/pricing';
const $bbb37991b0d02a24$export$203bbf35222be25b = 'jsm';
const $bbb37991b0d02a24$export$128ca612adf9bcff = 'jpd';
const $bbb37991b0d02a24$export$a217f4f87e1d9927 = 'jsw';

parcelRegister("lD9Ts", function(module, exports) {

$parcel$export(module.exports, "default", () => $b10c32ea43ab2c09$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b10c32ea43ab2c09$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    belowFreeUserLimitTitle: {
        "id": "lock-screen-experiment.common.below-free-user-limit-title",
        "defaultMessage": "Your 14-day trial of the Standard plan has ended"
    },
    belowFreeUserLimitTitlePremium: {
        "id": "lock-screen-experiment.common.below-free-user-limit-title-premium",
        "defaultMessage": "Your Premium trial has ended"
    },
    adminBelowFreeUserLimitInstruction: {
        "id": "lock-screen-experiment.common.admin-below-free-user-limit-instruction",
        "defaultMessage": "You've reached the end of your trial and not provided payment details. Add your payment details to stay on Standard, or switch to the Free plan."
    },
    adminAboveFreeUserLimitInstruction: {
        "id": "lock-screen-experiment.common.admin-above-free-user-limit-instruction",
        "defaultMessage": "You've reached the end of your trial and not provided payment details. To avoid losing your current data and setup, add your payment details to stay on Standard.{br}Or <link>learn how to switch to Free.</link>"
    },
    adminBelowFreeUserLimitInstructionPremium: {
        "id": "lock-screen-experiment.common.admin-below-free-user-limit-instruction-premium",
        "defaultMessage": "Add payment details to stay on Premium or <link>learn how to switch to Free</link>. If no action is taken, your account will be downgraded automatically."
    },
    adminAboveFreeUserLimitInstructionPremium: {
        "id": "lock-screen-experiment.common.admin-above-free-user-limit-instruction-premium",
        "defaultMessage": "Add payment details to stay on Premium or <link>learn how to switch to Free</link>. If no action is taken, your account will be deactivated."
    },
    billingAdminBenefitTitlePremium: {
        "id": "lock-screen-experiment.common.billing-admin-benefit-title-premium",
        "defaultMessage": "Add payment details to stay on Premium and keep:"
    },
    nonBillingAdminBenefitTitlePremium: {
        "id": "lock-screen-experiment.common.non-billing-admin-benefit-title-premium",
        "defaultMessage": "Stay on Premium and keep:"
    },
    billingAdminBenefitTitle: {
        "id": "lock-screen-experiment.common.billing-admin-benefit-title",
        "defaultMessage": "Add payment details to stay on Standard and keep:"
    },
    nonBillingAdminBenefitTitle: {
        "id": "lock-screen-experiment.common.non-billing-admin-benefit-title",
        "defaultMessage": "Stay on Standard and keep:"
    },
    contactBillingAdmin: {
        "id": "lock-screen-experiment.common.contact-billing-admin",
        "defaultMessage": "Contact your billing admin to request the full Standard plan for your team."
    },
    contactBillingAdminPremium: {
        "id": "lock-screen-experiment.common.contact-billing-admin-premium",
        "defaultMessage": "Contact your billing admin to request the full Premium plan for your team."
    },
    aboveFreeUserLimitTitleJsm: {
        "id": "lock-screen-experiment.common.above-free-user-limit-title-jsm",
        "defaultMessage": "Jira Service Management will be deactivated in {predunningDaysLeft} {predunningDaysLeft, plural, one {day} other {days}}"
    },
    aboveFreeUserLimitTitleJpd: {
        "id": "lock-screen-experiment.common.above-free-user-limit-title-jpd",
        "defaultMessage": "Jira Product Discovery will be deactivated in {predunningDaysLeft} {predunningDaysLeft, plural, one {day} other {days}}"
    },
    aboveFreeUserLimitTitleJswSpork: {
        "id": "lock-screen-experiment.common.above-free-user-limit-title-jsw-spork",
        "defaultMessage": "Jira will be deactivated in {predunningDaysLeft} {predunningDaysLeft, plural, one {day} other {days}}"
    },
    accessAllAgents: {
        "id": "lock-screen-experiment.common.access-all-agents",
        "defaultMessage": "Access for all of your agents"
    },
    accessAllCreators: {
        "id": "lock-screen-experiment.common.access-all-creators",
        "defaultMessage": "Access for all of your creators"
    },
    accessAllUsers: {
        "id": "lock-screen-experiment.common.access-all-users",
        "defaultMessage": "Access for all of your users"
    },
    businessHourSupport: {
        "id": "lock-screen-experiment.common.business-hour-support",
        "defaultMessage": "Business hour support"
    },
    dataResidency: {
        "id": "lock-screen-experiment.common.data-residency",
        "defaultMessage": "Data residency"
    },
    unlimitedEmailNotification: {
        "id": "lock-screen-experiment.common.unlimited-email-notification",
        "defaultMessage": "Unlimited email notifications"
    },
    learnMoreUrlText: {
        "id": "lock-screen-experiment.common.learn-more-url-text",
        "defaultMessage": "Learn more about the benefits of the Standard plan"
    },
    userRolesAndPermissions: {
        "id": "lock-screen-experiment.common.user-roles-and-permissions",
        "defaultMessage": "User roles and permissions"
    },
    aboveFreeUserLimitTitleJswPremium: {
        "id": "lock-screen-experiment.common.above-free-user-limit-title-jsw-premium",
        "defaultMessage": "Action required: Your trial has ended"
    },
    crossTeamTimelines: {
        "id": "lock-screen-experiment.common.cross-team-timelines",
        "defaultMessage": "Cross-team timelines"
    },
    releaseTracks: {
        "id": "lock-screen-experiment.common.release-tracks",
        "defaultMessage": "Sandbox and release tracks"
    },
    atlassianIntelligence: {
        "id": "lock-screen-experiment.common.atlassian-intelligence",
        "defaultMessage": "Atlassian Intelligence (AI)"
    },
    premiumLearnMoreUrlText: {
        "id": "lock-screen-experiment.common.premium-learn-more-url-text",
        "defaultMessage": "See more Premium features"
    }
});

});



parcelRegister("cbMif", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('67i0q')
        ]);
        const value = parcelRequire('btLcy');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("67i0q")
    ]).then(()=>parcelRequire('btLcy'));
}

});



parcelRegister("g4G5S", function(module, exports) {

$parcel$export(module.exports, "useProductEntitlementDetails", () => $c8efb20e27e18352$export$e02d6385b5d47f5d);

var $gd0Sp = parcelRequire("gd0Sp");
const $c8efb20e27e18352$export$e02d6385b5d47f5d = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.productEntitlementDetails || null;
};

});

const $a733f78220833320$export$b8b9d90f9e5bd72b = '@atlassian/jira-lock-screen-experiment-shared';
const $a733f78220833320$export$d57b6b390e78d90f = 'transmuters-growth';

parcelRegister("74ny8", function(module, exports) {

$parcel$export(module.exports, "useLockScreenService", () => $8d1aec08d53bd804$export$33c585774e52c9a2);

var $eUqFw = parcelRequire("eUqFw");

var $eEzyV = parcelRequire("eEzyV");

var $lRmyA = parcelRequire("lRmyA");
const $8d1aec08d53bd804$var$fetchLockScreenDetails = async (entitlementId)=>{
    if (!entitlementId) throw new Error('empty entitlementId');
    return (0, $lRmyA.performGetRequest)(`/gateway/api/growth/trial-end-lock-screen/is-locked?entitlementId=${entitlementId}`, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
};
const $8d1aec08d53bd804$export$33c585774e52c9a2 = ({ entitlementId: entitlementId, onError: onError })=>{
    const request = (0, $eUqFw.useCallback)(async ()=>{
        try {
            const result = await $8d1aec08d53bd804$var$fetchLockScreenDetails(entitlementId);
            return result;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            onError(err);
            throw err;
        }
    }, [
        entitlementId,
        onError
    ]);
    return (0, $eEzyV.useService)(request);
};

});

parcelRegister("3FDyv", function(module, exports) {

$parcel$export(module.exports, "useFeatureExposedEvent", () => $7218da3cf7aa0408$export$23ce6e1fb2ba7f83);
$parcel$export(module.exports, "getLocalEligibility", () => $7218da3cf7aa0408$export$9a41e8e8fae9628d);
$parcel$export(module.exports, "transformError", () => $7218da3cf7aa0408$export$78c6267359db7e73);

var $eUqFw = parcelRequire("eUqFw");

var $dpnxM = parcelRequire("dpnxM");

var $7ZZxN = parcelRequire("7ZZxN");

var $9CJ0P = parcelRequire("9CJ0P");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $6WXNs = parcelRequire("6WXNs");

var $1R3n5 = parcelRequire("1R3n5");
const $7218da3cf7aa0408$export$23ce6e1fb2ba7f83 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const isSiteAdmin = (0, $1R3n5.useIsSiteAdmin)();
    return (0, $eUqFw.useCallback)((ineligibilityReason, projectType, attributes = {}, edition)=>{
        const { cohort: cohort, fireExpExperimentExposure: fireExpExperimentExposure } = (0, $9CJ0P.getStatSigCohortAndExposureFunction)({
            projectType: projectType,
            edition: edition
        });
        if (ineligibilityReason === null) {
            fireExpExperimentExposure();
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'feature exposed', 'trialEndLockScreen', {
                ...ineligibilityReason === null ? {
                    cohort: cohort
                } : {
                    ineligibilityReason: ineligibilityReason,
                    originalCohort: cohort,
                    cohort: 'not-enrolled'
                },
                isSiteAdmin: isSiteAdmin,
                growthInitiative: 'transmuters',
                ...attributes
            });
        }
    }, [
        createAnalyticsEvent,
        isSiteAdmin
    ]);
};
const $7218da3cf7aa0408$export$9a41e8e8fae9628d = ({ projectType: projectType, edition: edition, entitlementDetails: entitlementDetails, billingSourceSystem: billingSourceSystem, entitlementId: entitlementId })=>{
    if (projectType === (0, $7ZZxN.SOFTWARE_PROJECT) && edition !== (0, $6WXNs.PREMIUM_EDITION) && edition !== (0, $6WXNs.STANDARD_EDITION)) return {
        eligible: false,
        ineligibilityReason: 'invalidSoftwareProjectTypeAndEditionCombo'
    };
    if (projectType === (0, $7ZZxN.CORE_PROJECT) && edition !== (0, $6WXNs.PREMIUM_EDITION)) return {
        eligible: false,
        ineligibilityReason: 'invalidBusinessProjectTypeAndEditionCombo'
    };
    if (projectType !== (0, $7ZZxN.SOFTWARE_PROJECT) && projectType !== (0, $7ZZxN.CORE_PROJECT) && edition !== (0, $6WXNs.STANDARD_EDITION)) return {
        eligible: false,
        ineligibilityReason: 'invalidEdition'
    };
    if (!entitlementDetails) return {
        eligible: false,
        ineligibilityReason: 'missingEntitlementDetails'
    };
    if (billingSourceSystem !== 'CCP') return {
        eligible: false,
        ineligibilityReason: 'notCCP'
    };
    if (entitlementDetails?.trialEndTime && (0, $dpnxM.default)(entitlementDetails.trialEndTime)) return {
        eligible: false,
        ineligibilityReason: 'inTrial'
    };
    if (!entitlementId) return {
        eligible: false,
        ineligibilityReason: 'missingEntitlementId'
    };
    return {
        eligible: true,
        ineligibilityReason: ''
    };
};
const $7218da3cf7aa0408$export$78c6267359db7e73 = (error)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    const errorObject = {};
    Object.getOwnPropertyNames(error).filter((name)=>name !== 'stack').forEach((name)=>{
        if (name === 'cause') errorObject[name] = error[name].message;
        else errorObject[name] = error[name];
    });
    return errorObject;
};

});



//# sourceMappingURL=async-lock-screen-experiment-shared.03bf4692.js.map
